type QuantityInput = number | string | null | undefined;

const PROSE_UNIT_MAP: Record<
  string,
  {
    singular: string;
    plural: string;
  }
> = {
  g: { singular: "gm", plural: "gms" },
  gram: { singular: "gm", plural: "gms" },
  grams: { singular: "gm", plural: "gms" },
  kilogram: { singular: "kg", plural: "kgs" },
  kilograms: { singular: "kg", plural: "kgs" },
  kg: { singular: "kg", plural: "kgs" },
  ml: { singular: "ml", plural: "mls" },
  milliliter: { singular: "ml", plural: "mls" },
  milliliters: { singular: "ml", plural: "mls" },
  liter: { singular: "liter", plural: "liters" },
  liters: { singular: "liter", plural: "liters" },
  serving: { singular: "serving", plural: "servings" },
  servings: { singular: "serving", plural: "servings" },
  cup: { singular: "cup", plural: "cups" },
  cups: { singular: "cup", plural: "cups" },
  slice: { singular: "slice", plural: "slices" },
  slices: { singular: "slice", plural: "slices" },
  piece: { singular: "piece", plural: "pieces" },
  pieces: { singular: "piece", plural: "pieces" },
  number: { singular: "number", plural: "numbers" },
  numbers: { singular: "number", plural: "numbers" },
};

const quantityFormatter = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const parseQuantity = (value: QuantityInput) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "string") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const formatQuantityValue = (value: number) => quantityFormatter.format(value);

export const formatUnitForProse = (unit: string | null | undefined, quantity: number) => {
  if (!unit) {
    return "";
  }

  const normalizedUnit = unit.trim().toLowerCase();
  if (!normalizedUnit) {
    return "";
  }

  const mapping = PROSE_UNIT_MAP[normalizedUnit];
  if (!mapping) {
    return unit.trim();
  }

  return Math.abs(quantity - 1) < 1e-6 ? mapping.singular : mapping.plural;
};

export const formatMealLine = (quantityInput: QuantityInput, unit: string | null | undefined, name: string) => {
  const numericQuantity = parseQuantity(quantityInput);
  const quantityLabel = numericQuantity !== null ? formatQuantityValue(numericQuantity) : String(quantityInput ?? "");
  const unitLabel = numericQuantity !== null ? formatUnitForProse(unit, numericQuantity) : unit?.trim() ?? "";
  const quantityWithUnit = unitLabel ? `${quantityLabel} ${unitLabel}` : quantityLabel;
  return `${quantityWithUnit} of ${name}`.trim();
};
